import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import TextLink from '@narvar/nth-text-link';

const mapStateToProps = ({
  retailerSettings: {
    branding: {
      link_color: linkColor,
      link_hover_color: linkHoverColor,
      brand_call_to_action: ctaColor,
    } = {},
  } = {},
  language: {
    'returns.printerless_info_page.barcode_placeholder_text': placeholderText,
    'returns.printerless_error_page.try_again_link_text': tryAgainLinkText,
  } = {},
  printerlessInfo: { barcodeUrl, partnerReturnCode } = {},
}) => ({
  linkColor,
  linkHoverColor,
  ctaColor,
  placeholderText,
  tryAgainLinkText,
  barcodeUrl,
  partnerReturnCode,
});

const BarcodeNumber = styled.div`
  margin: 0.5rem auto;
  letter-spacing: 0.3rem;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
`;

const PrinterlessBarcode = ({
  linkColor,
  linkHoverColor,
  ctaColor,
  barcodeUrl,
  placeholderText,
  tryAgainLinkText,
  partnerReturnCode,
}) => (
  <div style={{ width: '100%' }}>
    {barcodeUrl ? (
      <React.Fragment>
        <img src={barcodeUrl} alt="Printerless Return Code" style={{ maxWidth: '12.5rem' }} />
        {partnerReturnCode && <BarcodeNumber>{partnerReturnCode}</BarcodeNumber>}
      </React.Fragment>
    ) : (
      <div
        style={{
          position: 'relative',
          width: '10rem',
          height: '10rem',
          margin: '0 auto',
          border: `1px solid ${ctaColor}`,
        }}
      >
        <div
          style={{
            width: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <p>{placeholderText}</p>
          <TextLink
            href={window.location.href}
            s={{
              color: linkColor,
              hoverColor: linkHoverColor,
              textDecoration: 'underline',
            }}
          >
            {tryAgainLinkText}
          </TextLink>
        </div>
      </div>
    )}
  </div>
);

PrinterlessBarcode.defaultProps = {
  linkColor: '',
  linkHoverColor: '',
  ctaColor: '',
  barcodeUrl: '',
  placeholderText: 'Mobile Return Code did not load',
  tryAgainLinkText: 'Try Again',
  partnerReturnCode: '',
};

PrinterlessBarcode.propTypes = {
  linkColor: PropTypes.string,
  linkHoverColor: PropTypes.string,
  ctaColor: PropTypes.string,
  barcodeUrl: PropTypes.string,
  placeholderText: PropTypes.string,
  tryAgainLinkText: PropTypes.string,
  partnerReturnCode: PropTypes.string,
};

export { PrinterlessBarcode, mapStateToProps };
export default connect(mapStateToProps)(PrinterlessBarcode);
